module.exports = __webpack_public_path__ + "popover-gradient.d1d9c0b5.svg";